import React from "react";
import TableLayout from "../Layout/TableLayout";
import { getOrderStatusClass } from "../Layout/StatusStyle";
const DetailContent = ({ selectedObject }) => {
  const tableHeaders = [
    { label: "Product Name", value: "product_name" },
    { label: "Quantity", value: "quantity" },
    { label: "Rate", value: "rate" },
    // { label: "Description", value: "description" },
    { label: "Amount", value: "amount" },
  ];
  return (
    <div className="flex flex-col max-h-[80vh] overflow-y-auto md:min-h-[100vh] md:overflow-y-auto">
      {/* Header area */}
      <div className="sticky top-0 bg-white z-10 pb-4 pt-0 sm:pt-6 w-full">
        <div className=" items-center space-y-2">
          <h1 className="text-text1 text-2xl font-bold">
            Detail Purchase Order
          </h1>
          <span className="text-sm text-text3">
            {selectedObject.Name} | {selectedObject.created_date}
          </span>
        </div>
        <hr className="mt-5 mb-4" />
      </div>
      <div className="flex-1 overflow-x-hidden pb-24 sm:pb-8">
        <div className="space-y-0">
          {[
            { label: "Customer name", value: selectedObject.customer_name },
            { label: "Order date", value: selectedObject.created_date },
            {
              label: "Status",
              value: selectedObject.order_status,
            },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between py-3">
              <p className="font-medium text-base text-text3">{label}</p>
              <p className="font-medium text-base text-text1 text-right">
                {label === "Status" ? (
                  <span className={getOrderStatusClass(value)}>{value} </span>
                ) : (
                  value || ""
                )}
              </p>
            </div>
          ))}
        </div>
        <div>
          <TableLayout
            data={selectedObject.line_items}
            headers={tableHeaders}
          />
        </div>
        <div>
          {[
            { label: "Total quantity", value: selectedObject.total_quantity },
            { label: "Sub total", value: selectedObject.sub_total },
            {
              label: "CGST 2.5",
              value: selectedObject.cgst,
            },
            {
              label: "SGST 2.5",
              value: selectedObject.sgst,
            },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between py-3">
              <p className="font-medium text-base text-text3">{label}</p>
              <p className="font-medium text-base text-text1 text-right">
                {value || "0"}
              </p>
            </div>
          ))}

          <div className="flex justify-between py-4 border-t border-b border-gray-200">
            <p className="font-bold text-lg text-text3">Total Amount</p>
            <p className="font-bold text-lg text-text1 text-right">
              ₹{selectedObject.amount}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailContent;
